import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { H4, P } from "../../../AbstractElements";
import { Href, MyPortfolioTitle } from "../../../Constant";
import { GALLARY_IMAGE } from "../../../Data/Gallery";
import { dynamicImage } from "../../../Service/DynamicImage";

export const DescriptionMyGallery = () => {
  return (
    <Gallery>
      {GALLARY_IMAGE.map((item, index) => (
        <figure key={index} className="col-xl-3 col-sm-6 m-0" itemProp="caption description">
          <Item original={dynamicImage(item)} width="1500" height="850" caption="images">
            {({ ref, open }) => (
              <Link to={Href} onClick={open}>
                <img height="500" width="500" className="img-thumbnail border-bottom-0 p-2 rounded-0 rounded-top-1" ref={ref} src={dynamicImage(item)} alt="thumbnail" />
                <div className="caption border-top-0 p-2">
                  <H4>{MyPortfolioTitle}</H4>
                  <P>is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</P>
                </div>
              </Link>
            )}
          </Item>
        </figure>
      ))}
    </Gallery>
  );
};
